import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { map, bindAll, isFunction, get } from 'lodash-es'
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
  arrayMove,
} from 'react-sortable-hoc'

import { IconComponent } from '..'

import './DragDropComponent.scss'

const DragHandle = SortableHandle(() => (
  <IconComponent
    name="drag-handle"
    size={[5, 32]}
    color="CCC"
    className="drag-handle"
  />
))

const SortableItem = SortableElement(({ item, index, renderItem }) =>
  renderItem(item, index)
)

const SortableList = SortableContainer((opt) => {
  const {
    items,
    keyExtractor,
    renderItem,
    isDragging,
    className,
    wrapperTag: Tag,
  } = opt

  // the react-sortable-hoc needs the tag wrapper below, so keep it here
  return (
    <Tag
      className={classnames('drag-drop-component', className, {
        'is-dragging': isDragging,
      })}
    >
      {map(items, (item, index) => (
        <SortableItem
          key={keyExtractor(item)}
          index={index}
          renderItem={renderItem}
          item={item}
          {...(get(item, 'isDisabled', false) && { disabled: true })}
        />
      ))}
    </Tag>
  )
})

class DragDropComponent extends React.Component {
  constructor(props) {
    super(props)

    this.state = { isDragging: false }

    bindAll(this, 'onDragEnd', 'onDragStart')
  }

  onDragEnd({ oldIndex, newIndex }) {
    this.setState({ isDragging: false })

    const { onDragEnd, items } = this.props

    if (isFunction(onDragEnd)) {
      onDragEnd(arrayMove(items, oldIndex, newIndex))
    }
  }

  onDragStart() {
    this.setState({ isDragging: true })
  }

  render() {
    const {
      keyExtractor,
      renderItem,
      useDragHandle,
      sortDirection,
      lockAxis,
      wrapperTag,
      className,
      lockToContainerEdges,
      items,
    } = this.props
    const { isDragging } = this.state

    return (
      <SortableList
        items={items}
        onSortEnd={this.onDragEnd}
        onSortStart={this.onDragStart}
        axis={sortDirection}
        keyExtractor={keyExtractor}
        renderItem={renderItem}
        useDragHandle={useDragHandle}
        isDragging={isDragging}
        lockAxis={lockAxis}
        wrapperTag={wrapperTag}
        className={className}
        lockToContainerEdges={lockToContainerEdges}
        helperClass="dragged-item-wrapper"
      />
    )
  }
}

DragDropComponent.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  renderItem: PropTypes.func.isRequired,
  keyExtractor: PropTypes.func.isRequired,
  sortDirection: PropTypes.oneOf(['x', 'y', 'xy']),
  onDragEnd: PropTypes.func,
  useDragHandle: PropTypes.bool,
  lockAxis: PropTypes.oneOf(['x', 'y']),
  wrapperTag: PropTypes.string,
  className: PropTypes.string,
  lockToContainerEdges: PropTypes.bool,
}

DragDropComponent.defaultProps = {
  sortDirection: 'y',
  useDragHandle: false,
  lockToContainerEdges: false,
  wrapperTag: 'div',
  className: '',
}

export default DragDropComponent
export { DragHandle }
